import styled from 'styled-components';
import { SxProps, Theme } from '@mui/material';
import { ReactComponent as SearchIcon } from '../../../assets/search.svg';
import { Flex } from '../../Flex';
import IncrementSelector from '../../IncrementSelector';
import WidgetButton from '../../WidgetButton';
import { radius } from '../../../style/utils';

type ChartZoomControlsProps = {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
  disableZoomIn: boolean;
  disableZoomOut: boolean;
  disableReset: boolean;
  loading: boolean;
  vertical?: boolean;
  sx?: SxProps<Theme>;
};

const ZoomIconWrapper = styled(Flex)`
  background: ${({ theme }) => theme.palette.surface.base};
  height: 100%;
  width: 36px;
  justify-content: center;
  align-items: center;
`;

const ZoomIcon = styled(SearchIcon)`
  transform: scale(0.8);
  path {
    fill: ${({ theme }) => theme.palette.icon.primary};
  }
`;

const WidgetButtonStyled = styled(WidgetButton)`
  background: ${({ theme }) => theme.palette.surface.strong};
  color: ${({ theme }) => theme.palette.content.primary};
  border: 1px solid ${({ theme }) => theme.palette.border.muted};
  min-width: 0;
  height: 24px;
  border-radius: ${radius('lg')};

  :hover {
    border: 1px solid ${({ theme }) => theme.palette.border.muted};
    background: ${({ theme }) => theme.palette.surface.control};
  }

  :disabled {
    background: ${({ theme }) => theme.palette.surface.hover};
    border: 1px solid ${({ theme }) => theme.palette.border.muted};
  }
`;

const IncrementSelectorStyled = styled(IncrementSelector)`
  width: 80px;
  border: 1px solid ${({ theme }) => theme.palette.border.muted};

  button {
    background: ${({ theme }) => theme.palette.surface.strong};

    :hover {
      background: ${({ theme }) => theme.palette.surface.control};
    }
  }
`;

const ChartZoomControls = ({
  onZoomIn,
  onZoomOut,
  onReset,
  disableZoomIn,
  disableZoomOut,
  disableReset,
  loading,
  vertical,
  sx,
}: ChartZoomControlsProps) => (
  <Flex
    sx={{
      gap: 1,
      flexDirection: vertical ? 'column-reverse' : 'row',
      zIndex: 1,
      ...sx,
    }}
  >
    <WidgetButtonStyled
      variant="outlined"
      disabled={disableReset}
      onClick={onReset}
    >
      RESET
    </WidgetButtonStyled>

    <IncrementSelectorStyled
      onPlus={onZoomIn}
      onMinus={onZoomOut}
      disabled={loading}
      disablePlus={disableZoomIn}
      disableMinus={disableZoomOut}
      minusTooltip={disableZoomOut ? 'Minimum zoom level reached' : 'Zoom out'}
      plusTooltip={disableZoomIn ? 'Maximum zoom level reached' : 'Zoom in'}
    >
      <ZoomIconWrapper>
        <ZoomIcon />
      </ZoomIconWrapper>
    </IncrementSelectorStyled>
  </Flex>
);

export default ChartZoomControls;
